// Componente Configuracion para usuarios autenticados
// Muestra las opciones de configuración de la cuenta

import React from 'react';
import { FiSettings, FiBell, FiLock, FiEye, FiSmartphone, FiMail } from 'react-icons/fi';

/**
 * Componente Configuracion
 * 
 * Página de configuración para usuarios autenticados
 * Permite ajustar preferencias de la cuenta y privacidad
 */
const Configuracion = () => {
  return (
    <>
      {/* Header de la página */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Configuración
        </h2>
        <p className="mt-1 text-gray-600 dark:text-gray-400">
          Ajusta tus preferencias y configuración de privacidad.
        </p>
      </div>

      <div className="space-y-6">
        {/* Configuración de notificaciones */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
          <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <FiBell className="h-5 w-5 text-gray-400 mr-2" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                Notificaciones
              </h3>
            </div>
          </div>
          
          <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Notificaciones de nuevos matches
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Recibe alertas cuando tengas un nuevo match
                </p>
              </div>
              <button className="relative inline-flex h-6 w-11 items-center rounded-full bg-violet-500">
                <span className="inline-block h-4 w-4 transform rounded-full bg-white transition translate-x-6"></span>
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Notificaciones de mensajes
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Alertas cuando recibas nuevos mensajes
                </p>
              </div>
              <button className="relative inline-flex h-6 w-11 items-center rounded-full bg-violet-500">
                <span className="inline-block h-4 w-4 transform rounded-full bg-white transition translate-x-6"></span>
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Notificaciones de likes
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Sé notificado cuando alguien te dé like
                </p>
              </div>
              <button className="relative inline-flex h-6 w-11 items-center rounded-full bg-gray-300">
                <span className="inline-block h-4 w-4 transform rounded-full bg-white transition translate-x-1"></span>
              </button>
            </div>
          </div>
        </div>

        {/* Configuración de privacidad */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
          <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <FiLock className="h-5 w-5 text-gray-400 mr-2" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                Privacidad
              </h3>
            </div>
          </div>
          
          <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Perfil privado
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Solo las personas con las que hagas match podrán ver tu perfil
                </p>
              </div>
              <button className="relative inline-flex h-6 w-11 items-center rounded-full bg-gray-300">
                <span className="inline-block h-4 w-4 transform rounded-full bg-white transition translate-x-1"></span>
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Mostrar edad
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Permite que otros vean tu edad en el perfil
                </p>
              </div>
              <button className="relative inline-flex h-6 w-11 items-center rounded-full bg-violet-500">
                <span className="inline-block h-4 w-4 transform rounded-full bg-white transition translate-x-6"></span>
              </button>
            </div>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Mostrar distancia
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  Muestra la distancia aproximada a otros usuarios
                </p>
              </div>
              <button className="relative inline-flex h-6 w-11 items-center rounded-full bg-violet-500">
                <span className="inline-block h-4 w-4 transform rounded-full bg-white transition translate-x-6"></span>
              </button>
            </div>
          </div>
        </div>

        {/* Configuración de descubrimiento */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
          <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <FiEye className="h-5 w-5 text-gray-400 mr-2" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                Descubrimiento
              </h3>
            </div>
          </div>
          
          <div className="p-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Rango de edad
              </label>
              <div className="flex items-center space-x-4">
                <input
                  type="number"
                  value="25"
                  min="18"
                  max="100"
                  className="w-20 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg 
                           bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
                <span className="text-gray-500 dark:text-gray-400">a</span>
                <input
                  type="number"
                  value="35"
                  min="18"
                  max="100"
                  className="w-20 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg 
                           bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Distancia máxima
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg 
                               bg-white dark:bg-gray-700 text-gray-900 dark:text-white">
                <option>5 km</option>
                <option>10 km</option>
                <option selected>25 km</option>
                <option>50 km</option>
                <option>100 km</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Intereses buscados
              </label>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input type="checkbox" defaultChecked className="mr-2" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Hombres</span>
                </label>
                <label className="flex items-center">
                  <input type="checkbox" defaultChecked className="mr-2" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Mujeres</span>
                </label>
                <label className="flex items-center">
                  <input type="checkbox" className="mr-2" />
                  <span className="text-sm text-gray-700 dark:text-gray-300">Otros</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Configuración de cuenta */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
          <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <FiSettings className="h-5 w-5 text-gray-400 mr-2" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                Cuenta
              </h3>
            </div>
          </div>
          
          <div className="p-6 space-y-4">
            <button className="w-full text-left px-4 py-3 border border-gray-300 dark:border-gray-600 
                             rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FiMail className="h-5 w-5 text-gray-400 mr-3" />
                  <div>
                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                      Cambiar email
                    </p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      juan.perez@ejemplo.com
                    </p>
                  </div>
                </div>
                <span className="text-gray-400">→</span>
              </div>
            </button>

            <button className="w-full text-left px-4 py-3 border border-gray-300 dark:border-gray-600 
                             rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FiLock className="h-5 w-5 text-gray-400 mr-3" />
                  <div>
                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                      Cambiar contraseña
                    </p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      Última vez hace 3 meses
                    </p>
                  </div>
                </div>
                <span className="text-gray-400">→</span>
              </div>
            </button>

            <button className="w-full text-left px-4 py-3 border border-gray-300 dark:border-gray-600 
                             rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FiSmartphone className="h-5 w-5 text-gray-400 mr-3" />
                  <div>
                    <p className="text-sm font-medium text-gray-900 dark:text-white">
                      Verificación en dos pasos
                    </p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      No configurada
                    </p>
                  </div>
                </div>
                <span className="text-gray-400">→</span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Configuracion;
